import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { pluriel } from '@/lib/pluriel';
import { Card } from "@/components/admin/card";
import { ChipFilter } from "@/components/admin/chip-filter";
import { PageHead } from "@/components/admin/page-head";
import { Tag } from "@/components/admin/tag";
import { useReturnsList } from "@/lib/orders/orders-hooks";
import type { ReturnStatus } from "@/lib/orders/types";

const STATUSES: Array<[string, string]> = [
	["", "Toutes"],
	["REQUESTED", "À traiter"],
	["ACCEPTED", "Acceptées"],
	["IN_TRANSIT", "En transit"],
	["RECEIVED", "Reçues"],
	["INSPECTED", "Inspectées"],
	["REFUNDED", "Remboursées"],
	["REJECTED", "Refusées"],
];

const TAG_CLS: Record<
	ReturnStatus,
	"success" | "warning" | "danger" | "info" | "neutral"
> = {
	REQUESTED: "warning",
	ACCEPTED: "info",
	REJECTED: "neutral",
	IN_TRANSIT: "info",
	RECEIVED: "info",
	INSPECTED: "warning",
	REFUNDED: "success",
	DISPUTED: "danger",
};

export function AdminReturnsPage() {
	const navigate = useNavigate();
	const [filter, setFilter] = useState("");
	const { data, isLoading } = useReturnsList(filter || undefined);

	return (
		<>
			<PageHead title="Retours (RMA)" sub={pluriel(data?.length ?? 0, 'retour')} />

			<Card>
				<div className="toolbar">
					<div
						className="filter-bar"
						style={{ marginBottom: 0, flexWrap: "wrap" }}
					>
						{STATUSES.map(([k, l]) => (
							<ChipFilter
								key={k}
								on={filter === k}
								onClick={() => setFilter(k)}
							>
								{l}
							</ChipFilter>
						))}
					</div>
				</div>
				<div
					className="table-wrap returns-table"
					style={{ margin: 0, overflowX: "auto" }}
				>
					{isLoading ? (
						<div style={{ padding: 24 }}>Chargement…</div>
					) : (
						<table className="table">
							<thead>
								<tr>
									<th>N° RMA</th>
									<th>Commande</th>
									<th>Motif</th>
									<th>Statut</th>
									<th>Décision</th>
									<th>Créé</th>
								</tr>
							</thead>
							<tbody>
								{(data ?? []).map((r) => (
									<tr
										key={r.id}
										onClick={() => navigate(`/retours/${r.id}`)}
										style={{ cursor: "pointer" }}
									>
										<td className="mono">{r.number}</td>
										<td className="mono">{r.orderId.slice(0, 8)}…</td>
										<td>{r.reasonCode}</td>
										<td>
											<Tag variant={TAG_CLS[r.status]}>{r.status}</Tag>
										</td>
										<td>{r.decision ?? "—"}</td>
										<td>{new Date(r.createdAt).toLocaleString("fr-FR")}</td>
									</tr>
								))}
							</tbody>
						</table>
					)}
				</div>
			</Card>
		</>
	);
}
